import { UtiqStatusEntryName } from '@shared/constants/utiq';
import { getValidatedBase64Cookie } from '@shared/cookies/getValidatedBase64Cookie';
import { addEventListener } from '@shared/api/sharedAPIEventFunctions';
import { processConsentChangeFunction } from '@utiqLoader/consentHandling/getProcessConsentChangeFunction';
import { getHostname } from '@shared/getUtiqHost';
import { getVersions } from '@shared/helpers/getVersions';

export function setupCMPCustomAfterUtiq() {
  const Utiq = window.Utiq;
  if (!Utiq) throw new Error('window.Utiq === undefined');

  const updateConsent = (arg: unknown) => {
    if (typeof arg !== 'object') return;
    if (arg === null) return;
    if (!('isConsentGranted' in arg)) return;
    if (typeof arg.isConsentGranted !== 'boolean') return;
    const { isConsentGranted } = arg;

    const hostname = getHostname();

    if (!window.Utiq?.data?.popupContent?.version) return;
    if (!window.Utiq?.data?.popupContent?.versionPrevious) return;

    const consentVersion = getVersions(
      window.Utiq?.data?.popupContent?.version,
    ).majorVersion;

    const consentVersionPrevious = getVersions(
      window.Utiq?.data?.popupContent?.versionPrevious,
    ).majorVersion;

    if (!consentVersion) return;
    if (!consentVersionPrevious) return;

    processConsentChangeFunction(Utiq, isConsentGranted, {
      [hostname]: {
        name: 'customConsent',
        value: 'utiqConsent',
        consentVersion,
        consentVersionPrevious,
        consentParsed: isConsentGranted ? 'general:1' : 'general:0',
        consentState: isConsentGranted ? 'accepted' : 'rejected',
      },
    });
  };

  addEventListener('onConsentChanging', updateConsent);

  const currentConsentStatusCookie = getValidatedBase64Cookie(
    document.cookie,
    UtiqStatusEntryName,
  );
  if (currentConsentStatusCookie) {
    updateConsent({
      isConsentGranted: currentConsentStatusCookie === 'true',
    });
  }
}
